import axios from "axios";

// Declare a variable to hold the base URL
let baseURL = "";

// Use a switch or if/else for better readability when setting the baseURL
// This ensures that the logic for determining the URL is clear and centralized.
if (process.env.NODE_ENV === "development") {
  // Use a hardcoded development URL for predictable local testing.
  // This is safer than relying on a global window variable.
  baseURL = "https://orderapi.dukany.io/api/"; //prod
  // baseURL = "https://devsrvorderapi.dukany.io/api/"; //dev
} else {
  // For production or other environments, use the window.baseUrl.
  // A check is added to ensure it exists before assigning.
  if (window.baseUrl) {
    baseURL = window.baseUrl;
  }
}

// Create the Axios instance with the determined baseURL
export const instance = axios.create({
  baseURL: window.baseUrl,
  timeout: 100000,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default instance;
